import { useEffect, useRef, useState } from "react";
import { HiChevronDown, HiMenu, HiShoppingCart } from "react-icons/hi";
import { NavLink, useNavigate } from "react-router-dom";
import Button from "../User/Common/Button";
import { useCart } from "../../context/CartContext"; // adjust path if needed

const navItems = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Products", path: "/products" },
  { name: "Projects", path: "/projects" },
  { name: "Calculator", path: "/calculator" },
  { name: "Career", path: "/carrier" },
  { name: "Blogs", path: "/blog" },
  { name: "Contact", path: "/contact" },
];

function Navbar() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const { getTotalItems } = useCart();

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header
      ref={menuRef}
      className="w-full bg-[#F1F3F8] border-b border-gray-200"
    >
      {/* NAVBAR */}
      <div className="flex items-center justify-between min-h-[70px] px-4 sm:px-6 lg:px-10">
        {/* LEFT NAV */}
        <nav className="hidden xl:flex items-center gap-6 text-sm font-medium flex-1">
          {navItems.map((item) =>
            item.dropdown ? (
              <button
                key={item.name}
                className="flex items-center gap-1 hover:text-headingText transition"
              >
                {item.name}
                <HiChevronDown className="text-sm" />
              </button>
            ) : (
              <NavLink
                key={item.name}
                to={item.path}
                className={({ isActive }) =>
                  `transition hover:text-primaryAccentHover ${
                    isActive ? "text-primaryAccent font-semibold" : ""
                  }`
                }
              >
                {item.name}
              </NavLink>
            ),
          )}
        </nav>

        {/* CENTER LOGO */}
        <div
          onClick={() => navigate("/")}
          className="flex justify-center flex-shrink-0 cursor-pointer"
        >
          <img
            src="/logo.png"
            alt="Mix Masters"
            className="h-[3.4rem] sm:h-[4.2rem] object-contain"
          />
        </div>

        {/* RIGHT SIDE */}
        <div className="flex items-center justify-end flex-1 gap-4">
          {/* Cart Icon with Badge */}
          <NavLink
            to="/cart"
            className="relative text-[#041122] hover:text-primaryAccent transition"
          >
            <HiShoppingCart className="text-2xl" />
            {getTotalItems() > 0 && (
              <span className="absolute -top-2 -right-2 bg-[#B3129E] text-white text-[10px] rounded-full w-5 h-5 flex items-center justify-center font-bold">
                {getTotalItems()}
              </span>
            )}
          </NavLink>

          {/* DESKTOP CTA */}
          <div className="hidden xl:flex">
            <Button onClick={() => navigate("/contact")} text="Contact Us" />
          </div>

          {/* MOBILE MENU BUTTON */}
          <button className="xl:hidden text-2xl" onClick={() => setOpen(!open)}>
            <HiMenu />
          </button>
        </div>
      </div>

      {/* MOBILE MENU */}
      <div
        className={`xl:hidden border-t bg-white overflow-hidden transition-all duration-300 ease-in-out ${
          open
            ? "max-h-96 opacity-100 translate-y-0"
            : "max-h-0 opacity-0 -translate-y-2"
        }`}
      >
        <div className="grid grid-cols-2 px-4 py-4 gap-3 text-descriptionText">
          {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `text-left py-2 ${
                  isActive ? "text-primaryAccent font-semibold" : ""
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}

          <NavLink
            to="/contact"
            className="col-span-2 mt-2 bg-primaryAccent text-white text-center py-3 rounded-lg"
            onClick={() => setOpen(false)}
          >
            Contact Us
          </NavLink>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
